import { Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { viewImage } from '../../CommonUtils/viewImage';
import { FaEye } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
export default function AfflFfcaAppUploads() {
    const hasFetchedData = useRef(false)
    const acYear = sessionStorage.getItem('ac_year');
    let naviagte = useNavigate();
    function Backnav() {
        naviagte(-1)
    }
    const AfflAppFormik = useFormik({
        initialValues: {
        },
        onSubmit: (values) => {

        }
    })
    const userId = sessionStorage.getItem('user_id');
    const ffcaUserId = userId.split('ffca_')[1]
    const collCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const result = userId.startsWith("ffca") ? ffcaUserId : collCode;

    const [FfcaAppUploads, setFfcaAppUploads] = useState()
    function GetFfcaAppUploadsData() {
        let url = config?.url?.API_URL + `getMobileUploads/${result}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data !== undefined && res?.data !== null && res?.data !== '') {
                setFfcaAppUploads(res?.data);
            }
            else {
                setFfcaAppUploads([]);
            }

        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetFfcaAppUploadsData();
            hasFetchedData.current = true
        }
    }, [])
    return (
        <>

            <CommonFormHeading heading={`Affiliation FFCA College App Details ${acYear}`} />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <bie.Row style={{ textAlign: "right" }}>
                    <bie.Col xxl={12} xl={12} lg={12} md={10} sm={10} xs={10} ></bie.Col>
                    <bie.Col xxl={12} xl={12} lg={12} md={2} sm={2} xs={2} >
                        <bie.Button className='btn btn-sm primary ' onClick={Backnav}>
                            Back
                        </bie.Button>
                    </bie.Col>
                </bie.Row>
                <FormikProvider value={AfflAppFormik}>
                    <Form onChange={AfflAppFormik?.handleChange} onSubmit={AfflAppFormik?.handleSubmit} className="form_adjust" >
                        {FfcaAppUploads?.collUploads?.length > 0 ? (<>

                            <bie.Row className="px-2 pt-3 mb-3">
                                {FfcaAppUploads?.collUploads?.length > 0 && (<>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-responsive affl-table" role="presentation" aria-hidden="true">

                                            <tbody >

                                                <tr ><td className='text-left' >College Name:</td>
                                                    <td className='text-left'>{FfcaAppUploads?.collUploads[0]?.coll_name}</td>
                                                </tr>
                                                <tr>
                                                    <td className='text-left'>College Address:</td>
                                                    <td className='text-left'> {FfcaAppUploads?.collUploads[0]?.coll_address}</td>


                                                </tr>

                                                <tr>
                                                    <td className='text-left'>Latitude:	</td>
                                                    <td className='text-left'>{FfcaAppUploads?.collUploads[0]?.latitude}</td>


                                                </tr>
                                                <tr>
                                                    <td className='text-left'> Longitude</td>
                                                    <td className='text-left'>{FfcaAppUploads?.collUploads[0]?.longitude}</td>


                                                </tr>
                                                <tr>
                                                    <td className='text-left'>Address Upload:		</td>
                                                    <td className='text-left' >
                                                        {FfcaAppUploads?.collUploads?.[0]?.address_upload ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => viewImage(FfcaAppUploads?.collUploads[0]?.address_upload)}
                                                            >
                                                                <FaEye size={20} />
                                                            </button>
                                                        ) : (
                                                            <span>-</span>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className='text-left'> College Accommodation:</td>

                                                    <td className='text-left'>{FfcaAppUploads?.collUploads[0]?.coll_accomdation}</td>


                                                </tr>
                                                <tr> <td className='text-left'>College Exist in same premises:</td>
                                                    <td className='text-left'>{FfcaAppUploads?.collUploads[0]?.coll_exist_same_premises} </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </>)}
                                {FfcaAppUploads?.buildUploads?.length > 0 && (<>

                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0">  Building Uploads
                                        </h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Sl.No</th>
                                                    <th className='cen'>Building Image</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                </tr>
                                            </thead>
                                            {FfcaAppUploads?.buildUploads?.map((Building, index) => (
                                                <tbody>

                                                    <tr key={index + 1}>
                                                        <td> {index + 1}</td>
                                                        <td className='text-center'> {Building?.bulding_img ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => viewImage(Building?.bulding_img)}
                                                            >
                                                                <FaEye size={20} />
                                                            </button>
                                                        ) : (
                                                            <span>-</span>
                                                        )}</td>

                                                        <td className='text-left'> {Building?.latitude}</td>
                                                        <td className='text-left'> {Building?.longitude}</td>

                                                    </tr>

                                                </tbody>
                                            ))}
                                        </table>
                                    </div>
                                </>)}

                                {FfcaAppUploads?.clsRoomUploads?.length > 0 && (<>

                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0">  ClassRoom Uploads
                                        </h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Sl.No</th>
                                                    <th >ClassRoom Image</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>

                                                </tr>
                                            </thead>
                                            {FfcaAppUploads?.clsRoomUploads?.map((room, index) => (
                                                <tbody>

                                                    <tr key={index + 1}>
                                                        <td> {index + 1}</td>
                                                        <td className='text-center' style={{ fontSize: "15px" }}>{room?.clsroom_img ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => viewImage(room?.clsroom_img)}
                                                            >
                                                                <FaEye size={20} />
                                                            </button>
                                                        ) : (
                                                            <span>-</span>
                                                        )}</td>
                                                        <td className='text-left'> {room?.latitude}</td>
                                                        <td className='text-left'> {room?.longitude}</td>

                                                    </tr>

                                                </tbody>
                                            ))}
                                        </table>
                                    </div>
                                </>)}
                                {FfcaAppUploads?.labUploads?.length > 0 && (<>

                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0"> Lab Uploads
                                        </h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Sl.No</th>
                                                    <th>Course Name</th>
                                                    <th >Lab Image</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>

                                                </tr>
                                            </thead>
                                            {FfcaAppUploads?.labUploads?.map((labdata, index) => (
                                                <tbody>

                                                    <tr key={index + 1}>
                                                        <td > {index + 1}</td>
                                                        <td className='text-left'>{labdata?.course_cat_name}</td>
                                                        <td className='text-center' style={{ fontSize: "15px" }}>{labdata?.lab_img ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => viewImage(labdata?.lab_img)}
                                                            >
                                                                <FaEye size={20} />
                                                            </button>
                                                        ) : (
                                                            <span>-</span>
                                                        )}</td>
                                                        <td className='text-left'> {labdata?.latitude}</td>
                                                        <td className='text-left'> {labdata?.longitude}</td>

                                                    </tr>

                                                </tbody>
                                            ))}
                                        </table>
                                    </div>
                                </>)}
                                {FfcaAppUploads?.libraryUploads?.length > 0 && (<>

                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0"> Library Uploads
                                        </h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Sl.No</th>
                                                    <th>Library Image</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                </tr>
                                            </thead>
                                            {FfcaAppUploads?.libraryUploads?.map((librarydata, index) => (
                                                <tbody>

                                                    <tr key={index + 1}>
                                                        <td> {index + 1}</td>
                                                        {/* <td> {librarydata.library_img}</td> */}
                                                        <td className='text-center' style={{ fontSize: "15px" }}>{librarydata?.library_img ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => viewImage(librarydata?.library_img)}
                                                            >
                                                                <FaEye size={20} />
                                                            </button>
                                                        ) : (
                                                            <span>-</span>
                                                        )}</td>
                                                        <td className='text-left'> {librarydata?.latitude}</td>
                                                        <td className='text-left'> {librarydata?.longitude}</td>

                                                    </tr>

                                                </tbody>
                                            ))}
                                        </table>
                                    </div>
                                </>)}


                                {FfcaAppUploads?.parkingUploads?.length > 0 && (<>

                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0">Parking Uploads</h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Sl.No</th>
                                                    <th>Parking Image</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                </tr>
                                            </thead>
                                            {FfcaAppUploads?.parkingUploads?.map((parkingarea, index) => (
                                                <tbody>

                                                    <tr key={index + 1}>
                                                        <td> {index + 1}</td>
                                                        <td className='text-center' style={{ fontSize: "15px" }}>{parkingarea?.parking_area_img ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => viewImage(parkingarea?.parking_area_img)}
                                                            >
                                                                <FaEye size={20} />
                                                            </button>
                                                        ) : (
                                                            <span>-</span>
                                                        )}</td>
                                                        <td className='text-left'> {parkingarea?.latitude}</td>
                                                        <td className='text-left'> {parkingarea?.longitude}</td>

                                                    </tr>

                                                </tbody>
                                            ))}
                                        </table>
                                    </div>
                                </>)}

                                {FfcaAppUploads?.playGrndUploads?.length > 0 && (<>

                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0"> Playground  Uploads
                                        </h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Sl.No</th>
                                                    <th >Playground Image</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                </tr>
                                            </thead>
                                            {FfcaAppUploads?.playGrndUploads?.map((playground, index) => (
                                                <tbody>

                                                    <tr key={index + 1}>
                                                        <td> {index + 1}</td>
                                                        {/* <td> {playground.playgrnd_img}</td> */}
                                                        <td className='text-center'>{playground?.playgrnd_img ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => viewImage(playground?.playgrnd_img)}
                                                            >
                                                                <FaEye size={20} />
                                                            </button>
                                                        ) : (
                                                            <span>-</span>
                                                        )}</td>
                                                        <td className='text-left'> {playground?.latitude}</td>
                                                        <td className='text-left'> {playground?.longitude}</td>

                                                    </tr>

                                                </tbody>
                                            ))}
                                        </table>
                                    </div>
                                </>)}

                            </bie.Row>
                        </>) : (<center center className='text-danger h5 pt-5'>***** No Data Found *****</center>)}
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}